import { useOnClickOutside } from '@Shared/Hook/UseOnClickOutside';
import LinkSection from '@Web/Src/UI/LinkSection';
import { useRef, useState } from 'react';
import { assetUrl } from '@Shared/Helpers/Utilities';

function VideoSection({ src, link = '', videoImg, onClickLink }) {
    const [videoOpened, setVideoOpened] = useState(false);

    const ref = useRef();

    useOnClickOutside([ref], () => setVideoOpened(false));

    return (
        <div>
            <div className='relative mt-20 w-full'>
                <img className='w-full' src={videoImg} alt={'video image'} />
                {src && (
                    <img
                        onClick={() => setVideoOpened(true)}
                        className='!small:w-10 !medium:w-14 absolute left-1/2 top-1/2 w-40 -translate-x-1/2 -translate-y-1/2 transform cursor-pointer duration-200 hover:scale-110'
                        src={assetUrl('/assets/images/svg/web/unique/play.svg')}
                        alt={'play'}
                    />
                )}
            </div>
            {videoOpened && (
                <div className='w-full'>
                    <div
                        ref={ref}
                        className={'bg-dark fixed inset-0 z-30 opacity-80'}
                        onClick={() => setVideoOpened(false)}
                    />
                    <iframe
                        className={`hidde fixed left-1/2 top-1/3 z-40 max-h-[315px] max-w-[560px] -translate-x-1/2 -translate-y-1/2 overflow-hidden rounded-lg opacity-100 ${videoOpened && '!block'}`}
                        width='100%'
                        height='100%'
                        src={src}
                        title='YouTube video player'
                        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                        allowFullScreen
                        referrerPolicy='strict-origin-when-cross-origin'
                        frameBorder='0'
                    />
                </div>
            )}
            {link && (
                <LinkSection
                    link={link}
                    handleClick={() => {
                        if (onClickLink) onClickLink();
                        else
                            window.open(
                                'https://www.youtube.com/@ReferralFactory',
                                '_self',
                                'noopener, noreferrer'
                            );
                    }}
                />
            )}
        </div>
    );
}

export default VideoSection;
